<template>
  <v-container
    id="logs"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card icon="mdi-notebook-check-outline">
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('logs.viewlogs') }}
            </div>
          </template>
          <v-data-table
            :headers="tableHeader"
            :items="logData"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, 25, -1]
            }"
            :items-per-page="20"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :loading="loading"
            loading-text="Loading... Please wait"
            class="elevation-0"
          >
            <template #item.uid="{ item }">
              {{ item.uid.slice(0, 8) + '......' + item.uid.slice(item.uid.length-4) }}
            </template>
            <template #item.ts="{ item }">
              {{ getTime(item.ts) }}
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { fetchLog } from '@/firebase'
  import moment from 'moment'
  export default {
    data: () => ({
      sortBy: 'ts',
      sortDesc: true,

      logData: [],
    }),
    computed: {
      loading () {
        return !this.logData.length
      },
      tableHeader () {
        return [
          {
            text: this.$t('logs.id'),
            value: 'uid',
          },
          {
            text: this.$t('logs.timestamp'),
            value: 'ts',
          },
          {
            text: this.$t('logs.type'),
            value: 'type',
          },
          {
            text: this.$t('logs.message'),
            value: 'message',
          },
        ]
      },
    },
    mounted () {
      if (this.$can('read', 'logs')) {
        fetchLog(0, Date.now())
          .then(results => {
            this.logData = results
          })
      }
    },
    methods: {
      getTime (time) {
        return moment(time).format('DD.MM.YYYY HH:mm')
      },
    },
  }
</script>
